import { paramsApi } from '../../../helpers'
import apiV3 from '../../../helpers/apiV3'
import { loaded, loading } from '../../../layout/redux/layoutActions';


export const DASH_SET_LOADING = 'DASH_SET_LOADING';
export const DASH_SET_ERROR   = 'DASH_SET_ERROR';
export const DASH_SET_META    = 'DASH_SET_META';
export const DASH_SET_TOPIC   = 'DASH_SET_TOPIC';
export const DASH_SET_PAYLOAD = 'DASH_SET_PAYLOAD';
export const DASH_SET_NOTFOUND= 'DASH_SET_NOTFOUND';

export const setLoading = (b)   => ({ type: DASH_SET_LOADING, payload: b });
export const setError   = (e)   => ({ type: DASH_SET_ERROR, payload: e });
export const setMeta    = (m)   => ({ type: DASH_SET_META, payload: m });
export const setTopic   = (t)   => ({ type: DASH_SET_TOPIC, payload: t });
export const setPayload = (p)   => ({ type: DASH_SET_PAYLOAD, payload: p });
export const setNotFound = (b)  => ({ type: DASH_SET_NOTFOUND, payload: b });

export const fetchMeta = (dashboardId) => async (dispatch) => {
  dispatch(setLoading(true));
  dispatch(setNotFound(false));
  dispatch(setError(null));
  try {
    const r = await fetch(`${process.env.REACT_APP_INSV_API_V3}public-dashboards/${dashboardId}/meta`, {
      credentials: 'omit',
      cache: 'no-store'
    });
    
    if (r.status === 404) { dispatch(setNotFound(true)); return null; }
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    const meta = await r.json(); // { titulo, topics:[{key,label}] }
    dispatch(setMeta(meta));
    return meta;
  } catch (e) {
    dispatch(setError(String(e)));
    return null;
  } finally {
    dispatch(setLoading(false));
  }
};

export const fetchTopicData = (dashboardId, topicKey) => async (dispatch) => {
  dispatch(setLoading(true));
  dispatch(setError(null));
  try {
    const r = await fetch(`${process.env.REACT_APP_INSV_API_V3}public-dashboards/${dashboardId}/topic/${topicKey}`, {
      credentials: 'omit',
      cache: 'no-store'
    });
    
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    const payload = await r.json(); // { titulo, escopo, data:{items}, nls, autor }
    dispatch(setPayload(payload));
    return payload;
  } catch (e) {
    dispatch(setError(String(e)));
    return null;
  } finally {
    dispatch(setLoading(false));
  }
};

export const criarDashboard = (data) => async (dispatch) => {
  console.log('🔴 INICIANDO criarDashboard action');
  console.log('📦 Dados recebidos para criar dashboard:', data);

  dispatch(loading());
  
  try {
    const { titulo, autor, periodoAnalisado, youtube, idioma, config } = data;

    console.log('🎛️ Config recebido:', config);

    // ✅ VALIDAÇÃO DOS DADOS
    if (!titulo || !autor || !periodoAnalisado) {
      throw new Error('Dados obrigatórios faltando: titulo, autor ou periodoAnalisado');
    }

    if (!config) {
      throw new Error('Config é obrigatório');
    }

    const payload = {
      titulo: titulo,
      youtubeUrl: youtube || '', // ✅ passamos a Url do youtube. Antes era YoutubeId, mas mudamos.
      autor: autor,
      periodoAnalisado: periodoAnalisado,
      idioma: idioma || 'pt-BR', // ✅ valor padrão
      config: JSON.stringify(config)
    };

    console.log('🚀 Enviando para API - payload:', payload);

    
    const response = await apiV3.post('/public-dashboards/criadash', payload, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    console.log('✅ Resposta da API:', response.data);

    if (response.data && response.data.id) {
      console.log('🎉 Dashboard criado com sucesso! ID:', response.data.id);
      return response.data.id;
    } else {
      console.log('⚠️ API retornou sucesso mas sem ID:', response.data);
      throw new Error('API não retornou ID do dashboard');
    }

  } catch (error) {
    console.error('❌ Erro ao criar dashboard:', error);
    console.error('❌ Detalhes do erro:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status
    });
    throw error;
  } finally {
    // ✅ FINALIZA LOADING (sempre executa, mesmo com erro)
    dispatch(loaded());
  }

  
};



export const listarDashboards = () => async (dispatch) => {
  console.log('🔴 INICIANDO listarDashboards action');
  
  dispatch(loading());
  
  try {
    const response = await apiV3.get('/public-dashboards/listadashes', {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    console.log('✅ Resposta da API listarDashboards:', response.data);

    if (response.data && response.data.dashes) {
      console.log('🎉 Dashboards listados com sucesso! Total:', response.data.dashes.length);
      return response.data.dashes;
    } else {
      console.log('⚠️ API retornou sucesso mas sem dados:', response.data);
      throw new Error('API não retornou lista de dashboards');
    }

  } catch (error) {
    console.error('❌ Erro ao listar dashboards:', error);
    console.error('❌ Detalhes do erro:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status
    });
    
    throw error; // Apenas propaga o erro, o componente vai tratar
  } finally {
    dispatch(loaded());
  }
};


// dashboardActions.js - Adicione esta função
export const deletarDashboard = (dashboardId) => async (dispatch) => {
  console.log('🔴 INICIANDO deletarDashboard action');
  console.log('🗑️ Dashboard ID para deletar:', dashboardId);

  dispatch(loading());
  
  try {
    // ✅ VALIDAÇÃO DO ID
    if (!dashboardId) {
      throw new Error('ID do dashboard é obrigatório');
    }

    const payload = {
      id: dashboardId
    };

    console.log('🚀 Enviando para API deletar - payload:', payload);

    const response = await apiV3.delete('/public-dashboards/deletadash', {
      data: payload,
      headers: {
        'Content-Type': 'application/json'
      }
    });

    console.log('✅ Dashboard deletado com sucesso:', response.data);
    return response.data;

  } catch (error) {
    console.error('❌ Erro ao deletar dashboard:', error);
    console.error('❌ Detalhes do erro:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status
    });
    
    throw error;
  } finally {
    dispatch(loaded());
  }
};


// dashboardActions.js
export const obterPlanejamentoEscolhidoYT7dias = ({ empresaId, idiomaIdUser }) => async (dispatch) => {
  // Se você quiser evitar overlay global, pode remover loading/loaded aqui.
  dispatch(loading());

  try {
    if (!empresaId) throw new Error('empresaId não informado');
    if (!idiomaIdUser) throw new Error('idiomaIdUser não informado');

    const response = await apiV3.get('/Front/ListaUltimosPlanejamentos', {
      params: {
        empresaId: empresaId,
        IdiomaIdUser: idiomaIdUser,
        framework: 'YT7dias',
      },
      headers: {
        'Content-Type': 'application/json'
      }
    });

    const data = response?.data;

    const pe = data?.planejamentoescolhido ?? null;

    // Caso inesperado (sem objeto)
    if (!pe) {
      return { idPlanejamento: 0, nome: null };
    }

    // Caso A: idPlanejamento válido
    if (pe.idPlanejamento && Number(pe.idPlanejamento) !== 0) {
      return {
        idPlanejamento: Number(pe.idPlanejamento),
        nome: pe.nome ?? null,
      };
    }

    // Caso B: idPlanejamento = 0
    return {
      idPlanejamento: 0,
      nome: pe.nome ?? null, // pode ser null
    };
  } catch (err) {
    console.error('❌ Erro ao obter planejamento YT7dias:', err);
    // Caso C: erro
    return { idPlanejamento: 0, nome: null };
  } finally {
    dispatch(loaded());
  }
};

export const obterPlanejamentoEscolhidoYT30dias = ({ empresaId, idiomaIdUser }) => async (dispatch) => {
  dispatch(loading());

  try {
    if (!empresaId) throw new Error('empresaId não informado');
    if (!idiomaIdUser) throw new Error('idiomaIdUser não informado');

    const response = await apiV3.get('/Front/ListaUltimosPlanejamentos', {
      params: {
        empresaId: empresaId,
        IdiomaIdUser: idiomaIdUser,
        framework: 'YT30dias',
      },
      headers: {
        'Content-Type': 'application/json'
      }
    });

    const data = response?.data;
    const pe = data?.planejamentoescolhido ?? null;

    if (!pe) {
      return { idPlanejamento: 0, nome: null };
    }

    if (pe.idPlanejamento && Number(pe.idPlanejamento) !== 0) {
      return {
        idPlanejamento: Number(pe.idPlanejamento),
        nome: pe.nome ?? null,
      };
    }

    return {
      idPlanejamento: 0,
      nome: pe.nome ?? null,
    };
  } catch (err) {
    console.error('❌ Erro ao obter planejamento YT30dias:', err);
    return { idPlanejamento: 0, nome: null };
  } finally {
    dispatch(loaded());
  }
};

